import formatCount from '@/module/util/format-count'
import formatDate from '@/module/util/format-date'

const COLOR = [ '#efc8f8', '#abeee9', '#fbc3bd', '#8d92f1' ]

export default {
	props: {
		// Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
			required: true
		},
		oresponse: {
			type: Array
		},
		// List of all questionnaire responses
		questionnaire: {
			type: Array,
			required: true
		},
		histogram: {
			type: Boolean,
			default: false
		},
		patient: {
			type: Object
		},
		isSurvey: {
			type: Boolean
		},
		qNum: {
			type: Number
		},
		cnstFrmCnntd: {
			type: Boolean
		},
		isScored: {
			type: Boolean
		}
	},

	methods: {
		formatCount,
		formatDate,
		questionnaireDate(index) {
			if (this.questionnaire[index])
				return this.formatDate(this.questionnaire[index].completed)
		},
		valueList(response) {
			return this.valueMap(response.map((r) => ({ 0: r })))
		},
		valueMap(response, key) {
			var map = {}, total = 0, max = 0

			if (! response)
				return map

			response.forEach((r) => {
				if (typeof r === 'object')
					Object.keys(r).forEach((k) => {
						// Whether to use the key or the value as the map key
						if (! key)
							k = r[k]
						// Set map statistics
						map[k] = (map[k] || 0) + 1
						max = (map[k] > max) ? map[k] : max
						total++
					})
			})

			// Set up each mapped bin
			Object.keys(map).forEach((v) => {
				map[v] = {
					count: map[v],
					ratio: (1.0 * map[v] / total),
					ratioMax: (1.0 * map[v] / max),
					percent: Math.round(100.0 * map[v] / total) + '%',
					percentMax: Math.round(100.0 * map[v] / max) + '%',
				}
			})

			return map
		},
		selected(choice) {
			if (this.question.label || this.question.type == 'radio' || this.question.type == 'star')
				return this.analysis.find((a) => (parseInt(a.key) == choice))
			else if (this.question.select)
				return this.analysis.find((a) => (parseInt(a.key) == (choice - 1)))
			else if (this.question.option)
				return this.analysis.find((a) => (parseInt(a.key) == this.question.option[choice - 1]))
			else
				return null
		},
		displayValue(choice) {
			var selected = this.selected(choice)
			if (selected)
				return selected.value
			return ''
		},
		barHeight(choice) {
			var analysis = this.selected(choice)
			if (analysis != null)
				return (100.0 * analysis.value / this.maxValue) + '%'
			return '0%'
		},
		displayHeight(choice) {
			var analysis = this.selected(choice)
			if (! analysis) return ''
			return Math.round(100.0 * analysis.value / this.totalValue) + '%'
		}
	},

	computed: {
		maxValue() {
			var max = 0
			this.analysis.forEach((a) => {
				if (a.value >= max)
					max = a.value
			})
			return max
		},
		totalValue() {
			return this.analysis.map((a) => a.value).reduce((a, b) => (a + b), 0)
		},
		
	},

	components: {}
}
